import React, { useState } from 'react';
import { Modal } from './Modal';
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <footer className="py-12 bg-[#0D0D0D] border-t border-[#333]/30" data-id="element-22">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-23">
        <p className="text-[#A89F91]/40 text-sm" data-id="element-24">
          © 2024 REINICIO TOTAL 35+. Todos los derechos reservados.
        </p>

        <div className="flex items-center gap-6 text-sm" data-id="element-25">
          <button onClick={() => setIsPrivacyOpen(true)} className="text-[#A89F91]/60 hover:text-[#D4A853] transition-colors" data-id="element-26">
            Política de Privacidad
          </button>
          <button onClick={() => setIsTermsOpen(true)} className="text-[#A89F91]/60 hover:text-[#D4A853] transition-colors" data-id="element-27">
            Términos y Condiciones
          </button>
        </div>
      </div>

      {/* Privacy Modal */}
      <Modal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title="Política de Privacidad" data-id="element-28">
        <div className="space-y-4" data-id="element-29">
          <p data-id="element-30">
            <strong data-id="element-31">1. Información que recopilamos</strong>
            <br data-id="element-32" />
            Recopilamos información personal que usted nos proporciona
            voluntariamente cuando se registra en el sitio web, expresa interés
            en obtener información sobre nosotros o nuestros productos y
            servicios, al participar en actividades en el sitio web o al
            contactarnos.
          </p>
          <p data-id="element-33">
            <strong data-id="element-34">2. Uso de su información</strong>
            <br data-id="element-35" />
            Utilizamos la información personal recopilada a través de nuestro
            sitio web para diversos fines comerciales descritos a continuación.
            Procesamos su información personal para estos fines basándonos en
            nuestros intereses comerciales legítimos, para celebrar o cumplir un
            contrato con usted, con su consentimiento y/o para cumplir con
            nuestras obligaciones legales.
          </p>
          <p data-id="element-36">
            <strong data-id="element-37">3. Compartir su información</strong>
            <br data-id="element-38" />
            Solo compartimos información con su consentimiento, para cumplir con
            las leyes, para brindarle servicios, para proteger sus derechos o
            para cumplir con obligaciones comerciales.
          </p>
          <p data-id="element-39">
            <strong data-id="element-40">4. Seguridad de su información</strong>
            <br data-id="element-41" />
            Utilizamos medidas de seguridad administrativas, técnicas y físicas
            para proteger su información personal. Sin embargo, ninguna
            transmisión electrónica por Internet o tecnología de almacenamiento
            de información puede garantizarse al 100% segura.
          </p>
        </div>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Términos y Condiciones" data-id="element-42">
        <div className="space-y-4" data-id="element-43">
          <p data-id="element-44">
            <strong data-id="element-45">1. Aceptación de los términos</strong>
            <br data-id="element-46" />
            Al acceder y utilizar este sitio web, usted acepta estar sujeto a
            estos Términos y Condiciones. Si no está de acuerdo con alguno de
            estos términos, tiene prohibido usar o acceder a este sitio.
          </p>
          <p data-id="element-47">
            <strong data-id="element-48">2. Licencia de uso</strong>
            <br data-id="element-49" />
            Se concede permiso para descargar temporalmente una copia de los
            materiales (información o software) en el sitio web de REINICIO
            TOTAL 35+ solo para visualización transitoria personal y no
            comercial. Esta es la concesión de una licencia, no una
            transferencia de título.
          </p>
          <p data-id="element-50">
            <strong data-id="element-51">3. Descargo de responsabilidad</strong>
            <br data-id="element-52" />
            Los materiales en el sitio web de REINICIO TOTAL 35+ se proporcionan
            "tal cual". REINICIO TOTAL 35+ no ofrece garantías, expresas o
            implícitas, y por la presente renuncia y niega todas las otras
            garantías, incluyendo, sin limitación, garantías implícitas o
            condiciones de comerciabilidad, idoneidad para un propósito
            particular o no infracción de propiedad intelectual u otra violación
            de derechos.
          </p>
          <p data-id="element-53">
            <strong data-id="element-54">4. Limitaciones</strong>
            <br data-id="element-55" />
            En ningún caso REINICIO TOTAL 35+ o sus proveedores serán
            responsables de ningún daño (incluyendo, sin limitación, daños por
            pérdida de datos o beneficios, o debido a la interrupción del
            negocio) que surjan del uso o la incapacidad de usar los materiales
            en el sitio web de REINICIO TOTAL 35+.
          </p>
        </div>
      </Modal>
    </footer>;
}